<template>
  <transition name="slide">
    <div v-if="visible" class="fixed top-16 right-0 w-full max-w-3xl h-[calc(100%-4rem)] bg-white bg-yellow-100 rounded-md dark:bg-gray-800 shadow-lg z-50 overflow-y-auto p-6">
      <div class="flex justify-between items-center mb-2">
        <h2 class="text-xl font-bold text-gray-800 dark:text-white">Filters</h2>
        <button @click="$emit('close')" class="text-gray-600 dark:text-gray-300 hover:text-red-500 text-2xl p-2">
          &times;
        </button>
      </div>

      <slot></slot> <!-- Let parent inject filter UI -->

      <div class="mt-6 flex justify-start space-x-4">
        <button @click="$emit('apply')" class="bg-green-700 text-white px-4 py-2 rounded-md hover:bg-green-600">Apply Filters</button>
        <!-- <button @click="$emit('saveview')" class="bg-yellow-500 text-white px-4 py-2 rounded-md flex items-center font-medium hover:bg-yellow-400">
          <svg class="h-6 w-6 text-white mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z"/>
            <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
            <circle cx="12" cy="14" r="2" />
            <polyline points="14 4 14 8 8 8 8 4" />
          </svg>
          Save View
        </button> -->
        <button @click="$emit('clear')" class="text-white px-4 py-2 rounded-md bg-red-700 bg-red-500 hover:bg-red-600">{{ userroles.some(r => [60, 70, 80].includes(r)) ? 'Clear Filters' : 'Reset Default Filters' }}</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    userroles: Array
  }
};
</script>

<style scoped>
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from, .slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
